import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tabing_section healthcare_tabs_sec cloud_computing_tabs p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">
              Skills that Power Our <span>iOS Development</span>
            </h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              Building performant iOS solutions using new-age, efficient
              technologies to help businesses operate better and grow faster.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Languages">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/languages/Objective-C.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Objective-C</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/languages/swift.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Swift</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Frameworks & Libraries">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/frameworks/Alamofire.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Alamofire</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/frameworks/King_fisher.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Kingfisher</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/frameworks/rx_swift.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Rxswift</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/frameworks/Snap_Kit.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>SnapKit</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/frameworks/SwiftUI.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>SwiftUI</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/frameworks/UI_Kit.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>UIKit</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Testing Tools">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/qa/Appium.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Appium</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/qa/Fastlane.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Fastlane</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/qa/TestFlight.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>TestFlight</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/qa/XCTest.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>XCTest</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Build & CI/CD">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/build_cicl/Bitrise.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Bitrise</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/build_cicl/CircleCI.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>CircleCI</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/build_cicl/Jenkins.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Jenkins</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/build_cicl/xcode.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Xcode</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="App Monitoring">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/app_monitoring/AppDynamics.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>AppDynamics</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/app_monitoring/Firebase_Crashlytics.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Firebase Crashlytics</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/app_monitoring/Instabug.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Instabug</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/app_monitoring/New_Relic.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>New Relic</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="6" title="Databases">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/database/Core_Data.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Core Data</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/database/Firebase_Database.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Firebase Database </h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/database/Realm.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Realm</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/database/SQLite.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>SQLite</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="7" title="APIs & Integrations">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/api/ApplePay.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>ApplePay</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/api/FireBase.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>FireBase</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/api/GraphQL.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>GraphQL</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/api/RESTful_APIs.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Restful APIs</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="8" title="Cloud & Backend">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/cloud_platforms/aws.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>AWS</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/cloud_platforms/azure.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Azure</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/cloud_platforms/google_cloud.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Google Cloud</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
